import React from 'react';
import InputMask from 'react-input-mask';

import InputBase from 'apps/auth/components/form-multi/InputBase';
import { inputPropType } from 'apps/auth/helpers/customPropTypes';

const CardCvvFieldHOC = ({ field, ...props }) => {
    if (field.value === null) {
        field.value = '';
    }

    return (
        <InputMask mask="999" maskChar={null} value={field.value || ''} onFocus={props.onFocus} onChange={props.onChange} onBlur={props.onBlur}>
            {(inputProps) => (
                <input
                    {...inputProps}
                    id="inputCardCvv"
                    className="cvvMasked"
                    type="tel"
                    inputMode="numeric"
                    pattern="[0-9]*"
                    name="cvv-no-autofill"
                    autoComplete="off"
                    autoCorrect="off"
                    spellCheck="false"
                    autoFocus={props.focus}
                    ref={props.forwardedRef}
                />
            )}
        </InputMask>
    );
};

const CardCvvField = InputBase(CardCvvFieldHOC, false);

CardCvvField.propTypes = inputPropType(['text', 'cvv']);

export default CardCvvField;
